// src/api/bulk-assets-template.api.ts
// Mock API for downloading the bulk asset template

export async function downloadBulkAssetTemplate(): Promise<Blob> {
  // Simulate a CSV template as a Blob with real sample data
  const csvContent =
    'Asset Type,Tag ID,Serial Number,Make (Optional for ESCO),Weight (Optional for ESCO),Equipment Type (Optional for ESCO),Attachment Type (Optional for ESCO),Equipment Model (Optional for ESCO),Manufacturer (Optional for ESCO),Latitude (Optional),Longitude (Optional),Stock Number (Optional),Machine Number (Optional),Class (Optional),Capacity (Optional),Lip Width (Optional)\n' +
    'NON-ESCO,2-1234506,RH123457,KOMATSU,1.2,ES2022055,ES2022055,PC400,ESCO,80.12312,-120.123213,sn002,mn002,class1,100,200.1\n' +
    'ESCO,2-1234507,RH1234578,KOMATSU,100,,,,,,,,,,,\n';
  await new Promise((resolve) => setTimeout(resolve, 400));
  return new Blob([csvContent], { type: 'text/csv' });
}
